import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Popover, PopoverBody } from 'reactstrap'
import { SketchPicker } from 'react-color'

/**
 * ColorPicker
 * @param {object} props
 * @param {String} props.type
 * @param {String} props.id
 * @param {String} props.propName
 * @param {String} props.value
 * @param {Function} props.onChange
 * @param {String} props.placeholder
 * @param {String} props.label
 * @param {String} props.description
 * @param {Boolean} props.onlyRead
 */
const ColorPicker = (props) => {
  const { type, id, propName, value, onChange, placeholder, label, description, onlyRead } = props
  const [pickerOpen, setPickerOpen] = useState(false)
  const [color, setColor] = useState(value)// || '#E87721')

  useEffect(()=> {
    if (value)
      onChange(value)
  }, [])

  const onChangeComplete = (_color) => {
    setColor(_color.hex)
    onChange(_color.hex)
  }

  return (
    <div className='channel-field color'>
      {label && <label htmlFor={id}>{I18n.t(label)}</label>}
      <div className='color__container'>
        <div className='field-content grid grid--small'>
          <input
            type={type}
            id={id}
            name={propName}
            value={color}
            onChange={({ target }) => onChange(target.value)}
            placeholder={placeholder}
            readOnly={onlyRead}
          />
          <div id={`popover_${id}`} className='color__preview' style={{ backgroundColor: color }} onClick={() => setPickerOpen(!pickerOpen)}></div>
        </div>
        {description && <p className='description' dangerouslySetInnerHTML={{ __html: I18n.t(description) }} />}
      </div>
      <Popover
        id={`popover_${id}`}
        placement='right'
        isOpen={pickerOpen}
        target={`popover_${id}`}
        toggle={() => setPickerOpen(!pickerOpen)}
        className='popover-color-picker'
        trigger='legacy'
      >
        <PopoverBody>
          <SketchPicker
            id={`colorPicker_${id}`}
            color={color}
            onChangeComplete={onChangeComplete}
          />
        </PopoverBody>
      </Popover>
    </div>
  )
}

export default ColorPicker
